import { createContext, useContext } from 'react';
import { ICoreContext } from '@vivli/core/infrastructure/interface';

export const CoreContext = createContext<ICoreContext>(null);

export const useAppConfigContext = () => useContext(CoreContext).config;
export const useAssignedAppTypeContext = () => useContext(CoreContext).assignedAppType;
export const usePortalConfigContext = () => useContext(CoreContext).portalConfig;
// useModalApiContext now lives in modal.context.tsx (modal state is provided separately so opening a
// modal does not re-render every CoreContext consumer).
export const useToastApiContext = () => useContext(CoreContext).toastApi;
